
// wait for 2 secs after page load and attempt to load in all lazyload images
window.addEventListener('load', event => {
    setTimeout(function () {
        let lazyObj = window.lazySizes;
        let isLazyObj = (typeof lazyObj !== 'undefined') ? true : false;
        let images = document.querySelectorAll('img.lazyload');
        images.forEach(function (img) {
            if (isLazyObj) lazyObj.loader.unveil(img);
        })
    }, 2000);
});